
















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import { envCongif } from '../../shared/env.config';
const cssPrefix = 'wifiPlanner';

@Component({
  components: {
    MswAppTitle,
  },
})
export default class SwarmReport extends SwExtendedVue {
  cssPrefix = cssPrefix;
  accessCode: string = '';
  swarmURL: string = '';
  userId: any = this.$store.getters.getUserId;

  async generateCode() {
    const req = {
      tenantId : '',
      tileName: 'CTAREPORT332432',
    };
    await this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
    .then((result : any) => {
      this.$store.commit('stopLoading');
      if (result.operationStatus === 'OK') {
        this.accessCode =  result.content.accessCode || 'error';
      } else {
        this.accessCode = 'error';
      }
    });
  }

  async created() {
    await this.generateCode();
    /* tslint:disable-next-line */
    if (envCongif.env.toLowerCase().includes('sim') || envCongif.env.toLowerCase().includes('simulation')) {
      this.swarmURL = `https://swarmps.global.sonicwall.com?uname=${this.userId}&code=${this.accessCode}`;
    } else {
      this.swarmURL = `https://swarm.global.sonicwall.com/index.html?uname=${this.userId}&code=${this.accessCode}`;
    }
  }
}
